// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cellTopAligned {
  vertical-align: baseline;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/services/singleStudentRecord/styles.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,eAAe;AACjB","sourcesContent":[".cellTopAligned {\n  vertical-align: baseline;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
